// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-about-us-tsx": () => import("./../src/pages/aboutUs.tsx" /* webpackChunkName: "component---src-pages-about-us-tsx" */),
  "component---src-pages-content-tsx": () => import("./../src/pages/content.tsx" /* webpackChunkName: "component---src-pages-content-tsx" */),
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-navigation-tsx": () => import("./../src/pages/navigation.tsx" /* webpackChunkName: "component---src-pages-navigation-tsx" */),
  "component---src-pages-smm-tsx": () => import("./../src/pages/smm.tsx" /* webpackChunkName: "component---src-pages-smm-tsx" */),
  "component---src-pages-web-tsx": () => import("./../src/pages/web.tsx" /* webpackChunkName: "component---src-pages-web-tsx" */)
}

